export const SKILLS_BY_CAT = {
  "Tech / Dev": [
    "JavaScript",
    "TypeScript",
    "React",
    "Node.js",
    "Python",
    "Java",
    "C++",
    "Go",
    "Docker",
    "Kubernetes",
    "AWS",
    "Git",
    "SQL",
    "MongoDB",
    "GraphQL",
    "REST API",
    "Linux",
    "CI/CD",
    "Agile",
    "Vue.js",
  ],
  Creativo: [
    "Figma",
    "Adobe Photoshop",
    "Adobe Illustrator",
    "Adobe InDesign",
    "After Effects",
    "Premiere Pro",
    "Sketch",
    "Procreate",
    "Canva",
    "Blender",
    "Typography",
    "Branding",
    "UI Design",
    "UX Design",
    "Fotografia",
    "Video editing",
    "Motion graphics",
    "Cinema 4D",
  ],
  Marketing: [
    "Google Analytics",
    "Google Ads",
    "Meta Ads",
    "SEO",
    "SEM",
    "Email Marketing",
    "HubSpot",
    "Salesforce",
    "Content Marketing",
    "Social Media",
    "Copywriting",
    "A/B Testing",
    "CRM",
    "Mailchimp",
    "TikTok Ads",
    "Growth Hacking",
    "Power BI",
    "Tableau",
  ],
  "Startup / PM": [
    "Product Roadmap",
    "Agile",
    "Scrum",
    "Jira",
    "Notion",
    "Figma",
    "OKR",
    "KPI",
    "A/B Testing",
    "User Research",
    "Data Analysis",
    "SQL",
    "Pitch Deck",
    "Fundraising",
    "Go-to-market",
    "Stakeholder Management",
    "Trello",
    "Lean Startup",
  ],
  "Sales / BD": [
    "CRM",
    "Salesforce",
    "HubSpot",
    "Negoziazione",
    "Cold Calling",
    "LinkedIn Sales Navigator",
    "Pipeline Management",
    "Account Management",
    "Business Development",
    "Forecasting",
    "Upselling",
    "Customer Success",
    "B2B Sales",
    "B2C Sales",
    "Excel",
  ],
  "Finance / Law": [
    "Excel avanzato",
    "Bloomberg",
    "SAP",
    "Analisi finanziaria",
    "Contabilità",
    "Revisione contabile",
    "Diritto societario",
    "Contrattualistica",
    "Due Diligence",
    "Valutazione d'azienda",
    "IFRS",
    "Power BI",
    "Modelli finanziari",
    "M&A",
    "Compliance",
    "GDPR",
  ],
  Consulting: [
    "PowerPoint",
    "Excel",
    "Analisi dati",
    "Problem solving",
    "Project Management",
    "Modelli finanziari",
    "Business Strategy",
    "Process Improvement",
    "Change Management",
    "Workshop facilitation",
    "SQL",
    "Tableau",
    "Lean",
    "Six Sigma",
    "Ricerca di mercato",
  ],
  Management: [
    "Leadership",
    "Team Management",
    "Budget planning",
    "P&L",
    "OKR",
    "KPI",
    "Negoziazione",
    "Stakeholder Management",
    "Coaching",
    "Mentoring",
    "Project Management",
    "Excel",
    "PowerPoint",
    "Strategic planning",
  ],
  Accademia: [
    "Ricerca scientifica",
    "Pubblicazioni accademiche",
    "LaTeX",
    "SPSS",
    "R",
    "Python",
    "MATLAB",
    "Analisi statistica",
    "Grant writing",
    "Supervisione tesi",
    "Didattica",
    "Peer review",
    "Zotero",
    "Inglese accademico",
  ],
  Istruzione: [
    "Progettazione didattica",
    "Gestione classe",
    "LIM",
    "Google Classroom",
    "Moodle",
    "Valutazione",
    "Inclusione scolastica",
    "BES",
    "DSA",
    "Pedagogia",
    "Psicologia dello sviluppo",
    "Inglese",
    "Matematica",
    "Didattica per competenze",
  ],
  "PA / Non-profit": [
    "Normativa pubblica",
    "Atti amministrativi",
    "Protocollazione",
    "Bandi europei",
    "Rendicontazione fondi",
    "Project management",
    "Excel",
    "Word",
    "Comunicazione istituzionale",
    "Fundraising",
    "GDPR",
  ],
  Sanità: [
    "Diagnosi clinica",
    "Cartella clinica elettronica",
    "ECG",
    "Ecografia",
    "Farmacologia",
    "Protocolli clinici",
    "BLS",
    "ACLS",
    "Terapia intensiva",
    "Psicologia clinica",
    "Riabilitazione",
    "Fisioterapia",
    "Comunicazione col paziente",
    "Ricerca clinica",
    "GDPR sanitario",
  ],
  Ingegneria: [
    "AutoCAD",
    "SolidWorks",
    "MATLAB",
    "Python",
    "C++",
    "PLC",
    "FEM",
    "BIM",
    "Revit",
    "Gestione cantiere",
    "Sicurezza sul lavoro",
    "ISO 9001",
    "Lean Manufacturing",
    "Six Sigma",
    "Project Management",
    "SAP",
  ],
  Architettura: [
    "AutoCAD",
    "Revit",
    "Rhino",
    "SketchUp",
    "BIM",
    "ArchiCAD",
    "Lumion",
    "Photoshop",
    "InDesign",
    "Rendering",
    "Normativa edilizia",
    "Direzione lavori",
    "Sostenibilità",
    "LEED",
    "Gestione cantiere",
    "Blender",
  ],
  Ristorazione: [
    "Cucina italiana",
    "Pasticceria",
    "HACCP",
    "Gestione cucina",
    "Menu engineering",
    "Food cost",
    "Tecniche di servizio",
    "Sommellerie",
    "Mixology",
    "Gestione magazzino",
    "Allergeni",
    "Cucina internazionale",
    "Sous vide",
  ],
  "Luxury / Fashion": [
    "Visual merchandising",
    "Retail management",
    "Customer experience",
    "CRM luxury",
    "Styling",
    "Fashion buying",
    "Trend forecasting",
    "Adobe Illustrator",
    "Brand management",
    "Luxury retail",
    "E-commerce",
    "Fotografia moda",
  ],
  "Media / Giornalismo": [
    "Scrittura giornalistica",
    "SEO",
    "WordPress",
    "CMS",
    "Social media",
    "Fact-checking",
    "Fotografia",
    "Video editing",
    "Premiere Pro",
    "Adobe Audition",
    "Podcast",
    "Newsletter",
    "Google Analytics",
    "Diritto dell'informazione",
  ],
  "Neo-laureati": [
    "Microsoft Office",
    "Google Workspace",
    "PowerPoint",
    "Excel",
    "Teamwork",
    "Problem solving",
    "Comunicazione",
    "Inglese",
    "Social media",
    "Canva",
    "Time management",
    "Ricerca",
    "Adattabilità",
  ],
};

export const DEFAULT_SKILLS = [
  "Microsoft Office",
  "Excel",
  "PowerPoint",
  "Inglese",
  "Problem solving",
  "Lavoro in team",
  "Comunicazione",
  "Leadership",
  "Project Management",
];

export const getSkillsForTemplate = (tpl) => {
  if (!tpl) return DEFAULT_SKILLS;
  return SKILLS_BY_CAT[tpl.cat] || DEFAULT_SKILLS;
};
